import { useQuery } from "@tanstack/react-query";
import AppContext from "PFApp/app_context";
import { useSession } from "PFApp/use_session";
import { fetchSupplyStats, SupplyStatsData } from "PFCore/services/supply_reports";
import { QueryOptions } from "PFTypes/request_options";
import { useContext } from "react";

import { queryKeys } from "./query_keys";

type UseSupplyStatsQuery = {
  params: Record<string, string>;
};

export const useSupplyStatsQuery = (
  { params }: UseSupplyStatsQuery,
  options?: QueryOptions<SupplyStatsData>
) => {
  const session = useSession();
  const {
    store: { currentAccount }
  } = useContext(AppContext);
  return useQuery<SupplyStatsData>(
    queryKeys.supplyStats(params),
    () => fetchSupplyStats(session.getAccessToken(), currentAccount.full_domain, params),
    options
  );
};
